import { Card, Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../common/components/Page";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EFileOption } from "../../models/e-file/e-file-option";
import useEFile from "./useEFile";
import { updateEFileOptions } from "../../state/eFileStore";
import { RootState } from "../../store";

const EFile = () => {
  const dispatch = useDispatch();
  const { selectOption, eFileData, optionsLoader, redirectToLookup } = useEFile();
  const [options, setOptions] = useState<EFileOption[]>([]);
  const { activeCaseNumber } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    if (!activeCaseNumber) {
      redirectToLookup();
    }
    if (eFileData?.List) {
      dispatch(updateEFileOptions(eFileData?.List));
      setOptions(eFileData?.List);
    }
  }, [eFileData]);
  return (
    <Page loading={optionsLoader}>
      <Page.Title icon="check" title="E-File" />
      <Page.Content>
        <Row gutter={[16, 16]} >
          {options.map((file, index) =>
            <Col xs={24} sm={12} md={12} lg={12} xl={12} key={file?.OptionId}>
              <Card
                style={{height:"100%"} }
                hoverable
                className="erp-shortcut"
                cover={
                  <div style={{ textAlign: "center", padding: "none" }}>
                    <FontAwesomeIcon className="erp-shortcut-icon" icon="search" size="2x" />
                  </div>
                }
                onClick={() => selectOption(file)}
              >
                <div style={{ textAlign: "center" }}>
                  <h2>{file?.Description}</h2>
                </div>
                {file?.FeeAmount>0 && (file?.IsFeeImmediate ? (<div style={{ textAlign: "center" }}>
                  <Typography.Text italic>{`A filing fee of $${file?.FeeAmount} will be due to file this option.`}</Typography.Text>
                </div>)
                : (<div style={{ textAlign: "center" }}>
                  <Typography.Text italic>{`A delayed filing fee of $${file?.FeeAmount} is required to file this option.`}</Typography.Text>
                 </div>))}
              </Card>
            </Col>
          )}
        </Row>
      </Page.Content>
    </Page>
  );
};

export default EFile;
